<form [formGroup]="form" *ngIf="form">
  <div class="p-d-flex p-flex-column p-fluid gap-12">
    <!-- Naziv pravila -->
    <div>
      Naziv će biti generisan po pravilu:
      <strong>{{ delovodnikDto?.nazivPravila }}</strong>
    </div>
    <!-- Podbroj i kategorija -->
    <div class="p-d-flex p-flex-row p-justify-between p-fluid gap-6">
      <div class="flex-1">
        <kodit-text-input-field
          [formCtrl]="form.controls.podbroj!"
          formCtrlId="podbroj"
          formCtrlLabel="Podbroj"
        ></kodit-text-input-field>
      </div>
      <div class="flex-1">
        <kodit-field fieldLabel="Kategorija dokumentarnog materijala">
          <kodit-dokumentarna-kategorija-autocomplete
            [formCtrl]="form.controls.kategorijaId"
            [selectedKategorija]="isEdit ? selectedKategorijaNaziv : delovodnikDto?.kategorijaNaziv"
            [jeUnosDelovodnogDokumenta]="true"
          ></kodit-dokumentarna-kategorija-autocomplete>
        </kodit-field>
      </div>
    </div>
    <!-- Datum nastanka i unosa -->
    <div class="p-d-flex p-flex-row p-justify-between p-fluid gap-6">
      <div class="flex-1">
        <kodit-field fieldLabel="Datum nastanka">
          <kodit-calendar
            [formCtrl]="form.controls.datumNastanka!"
            class="p-fluid"
            formCtrlId="datumnastanka"
          ></kodit-calendar>
        </kodit-field>
      </div>
      <div class="flex-1">
        <kodit-field fieldLabel="Datum unosa">
          <kodit-calendar
            [formCtrl]="form.controls.datumUnosa!"
            class="p-fluid"
            formCtrlId="datumUnosa"
          ></kodit-calendar>
        </kodit-field>
      </div>
    </div>
    <!-- Stranka -->
    <div class="flex-1">
      <kodit-field fieldLabel="Pošiljalac">
        <kodit-posaljilac-dokumenta-autocomplete
          [formCtrl]="form.controls.strankaRacunaDto">
        </kodit-posaljilac-dokumenta-autocomplete>
      </kodit-field>
    </div>
    <!-- Ako postoji fajl onda ga prikazati -->
    <kodit-field fieldLabel="Postojeći prilog" *ngIf="isEdit && hasExistingFile">
      <div class="p-d-flex p-ai-center p-jc-between gap-2">
        <span class="flex-1">{{ form.controls.originalFileName.value }}</span>
        <button
          pButton
          pRipple
          type="button"
          icon="fas fa-trash"
          class="p-button-text p-button-danger p-button-sm"
          (click)="removeExistingFile()"
        ></button>
      </div>
    </kodit-field>

    <!-- Ako ne postoji fajl onda prikazi formu za upload -->
    <div *ngIf="!hasExistingFile">
      <kodit-field
        fieldLabel="Dodatni prilog"
        fieldLabelFor="attachment"
      >
        <kodit-file-upload
          (onUpload)="onUpload($event)"
          fileTypes=".jpg,.png,.jpeg,.pdf"
          [shouldAutoUpload]="true"
          [allowMultipleFiles]="false"
        ></kodit-file-upload>
      </kodit-field>
    </div>
  </div>
</form>